<template>
  <v-container>
    <!-- KPI Dashboard Section - Solo para tienda actual -->
    <v-row class="mb-6">
      <v-col cols="12" md="3">
        <v-card
          class="elevation-3 order-kpi-card"
          :style="{ borderTop: '4px solid #1976D2' }"
          height="100%"
        >
          <v-card-text>
            <div class="d-flex align-center mb-2">
              <v-icon color="primary" size="24" class="mr-2"
                >mdi-file-document-multiple</v-icon
              >
              <span class="text-h6 font-weight-bold">Total Órdenes</span>
            </div>
            <div class="text-h3 primary--text font-weight-light">
              {{ order_list.length }}
            </div>
            <div class="caption grey--text d-flex align-center mt-1">
              <v-icon x-small class="mr-1" color="success">mdi-calendar-range</v-icon>
              En el período seleccionado
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card
          class="elevation-3 order-kpi-card"
          :style="{ borderTop: '4px solid #4CAF50' }"
          height="100%"
        >
          <v-card-text>
            <div class="d-flex align-center mb-2">
              <v-icon color="success" size="24" class="mr-2"
                >mdi-package-variant-closed</v-icon
              >
              <span class="text-h6 font-weight-bold">Total Unidades</span>
            </div>
            <div class="text-h3 success--text font-weight-light">
              {{ getTotalOrderedQty }}
            </div>
            <div class="caption grey--text mt-1">
              {{ getDeliveredPercentage }}% entregadas
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card
          class="elevation-3 order-kpi-card"
          :style="{ borderTop: '4px solid #FF9800' }"
          height="100%"
        >
          <v-card-text>
            <div class="d-flex align-center mb-2">
              <v-icon color="warning" size="24" class="mr-2">mdi-clock-time-four</v-icon>
              <span class="text-h6 font-weight-bold">Edad Promedio</span>
            </div>
            <div class="text-h3 warning--text font-weight-light">{{ getAverageAge }}</div>
            <div class="caption grey--text mt-1">días desde la creación</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card
          class="elevation-3 order-kpi-card"
          :style="{ borderTop: '4px solid #E91E63' }"
          height="100%"
        >
          <v-card-text>
            <div class="d-flex align-center mb-2">
              <v-icon color="error" size="24" class="mr-2">mdi-currency-usd</v-icon>
              <span class="text-h6 font-weight-bold">Valor Total</span>
            </div>
            <div class="text-h3 error--text font-weight-light">
              {{ formatCurrency(getTotalOrderedCost) }}
            </div>
            <div class="caption grey--text mt-1">en órdenes de compra</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Filtros simplificados - Solo proveedor y fechas -->
    <v-card class="elevation-4 mb-6">
      <v-card-title class="pa-0">
        <v-toolbar flat>
          <v-icon class="ml-4">mdi-filter-variant</v-icon>
          <v-toolbar-title class="ml-4">
            <span class="text-h6 text--blue font-weight-bold">Filtros</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="py-4">
        <v-row align="center" justify="space-between">
          <!-- Selector de proveedor -->
          <v-col cols="12" md="4" class="py-2">
            <v-autocomplete
              v-model="filters.supplier"
              :items="suppliers"
              label="Proveedor"
              item-value="code"
              item-text="nombre"
              outlined
              hide-details="auto"
              return-object
              dense
              prepend-inner-icon="mdi-domain"
            />
          </v-col>

          <!-- Filtros de fecha -->
          <v-col cols="12" md="3" class="py-2">
            <v-text-field
              v-model="filters.dateFrom"
              label="Desde"
              hide-details="auto"
              dense
              outlined
              type="date"
              prepend-inner-icon="mdi-calendar-start"
            />
          </v-col>
          <v-col cols="12" md="3" class="py-2">
            <v-text-field
              v-model="filters.dateTo"
              label="Hasta"
              outlined
              hide-details="auto"
              dense
              type="date"
              prepend-inner-icon="mdi-calendar-end"
            />
          </v-col>
          <v-col cols="12" md="2" class="py-2">
            <v-btn color="primary" @click="get_orders" block :loading="loading_status">
              <v-icon left>mdi-magnify</v-icon>
              Buscar Órdenes
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Tabla de órdenes simplificada -->
    <v-card class="elevation-4">
      <v-card-title class="pa-0">
        <v-toolbar flat>
          <v-icon class="ml-4">mdi-file-document-multiple</v-icon>
          <v-toolbar-title class="ml-4">
            <span class="text-h6 text--blue font-weight-bold"
              >Órdenes de Compra - {{ currentStoreName }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="new_order" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Nueva Orden
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="order_list"
        :items-per-page="10"
        item-key="id"
        mobile-breakpoint="0"
        sort-by="order_date"
        class="elevation-0"
        :loading="loading_status"
        loader-height="10"
        loading-text="Cargando órdenes..."
        @click:row="get_e_doc"
      >
        <template #item.order_date="{ item }">
          <span class="font-weight-medium">{{ formatDate(item.order_date) }}</span>
        </template>

        <template #item.order_id="{ item }">
          <div class="d-flex align-center">
            <v-icon small color="primary" class="mr-1">mdi-file-document-outline</v-icon>
            <span class="font-weight-bold">{{ item.order_id }}</span>
          </div>
        </template>

        <template #item.proveedor="{ item }">
          <span>{{ item.proveedor }}</span>
        </template>

        <template #item.order_age="{ item }">
          <v-chip small :color="getAgeColor(item.order_age)" text-color="white" label>
            {{ item.order_age }} días
          </v-chip>
        </template>

        <template #item.ordered_qty="{ item }">
          <span class="font-weight-bold">{{ item.ordered_qty }}</span>
        </template>

        <template #item.delivered_qty="{ item }">
          <span
            :class="
              item.delivered_qty >= item.ordered_qty
                ? 'success--text font-weight-bold'
                : ''
            "
          >
            {{ item.delivered_qty }}
          </span>
        </template>

        <template #item.difference_qty="{ item }">
          <v-chip
            x-small
            :color="item.difference_qty > 0 ? 'warning' : 'success'"
            text-color="white"
            v-if="item.difference_qty >= 0"
          >
            {{ item.difference_qty }}
          </v-chip>
          <v-chip x-small color="error" text-color="white" v-else>
            {{ item.difference_qty }}
          </v-chip>
        </template>

        <template #item.ordered_cost="{ item }">
          <span class="font-weight-bold">{{ formatCurrency(item.ordered_cost) }}</span>
        </template>

        <template #item.actions="{ item }">
          <v-btn
            icon
            small
            color="primary"
            @click.stop="get_e_doc(item)"
            title="Ver detalles"
          >
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>

        <template #no-data>
          <div class="pa-4 text-center">
            <v-icon x-large color="grey lighten-1" class="mb-2"
              >mdi-clipboard-text-outline</v-icon
            >
            <p class="grey--text text--darken-1">
              No hay órdenes que mostrar para los criterios seleccionados.
            </p>
            <v-btn color="primary" @click="get_orders">Buscar Órdenes</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Loading Dialog -->
    <v-dialog v-model="loading_status" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-6">
          <div class="d-flex align-center mb-3">
            <v-progress-circular
              indeterminate
              color="white"
              class="mr-3"
            ></v-progress-circular>
            <p class="mb-0 text-h6">Procesando</p>
          </div>
          <p>{{ this.lStatus }}</p>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Document Viewer Dialog -->
    <noteViewer
      :item="item"
      :dialog="dialog"
      @close="dialog = false"
      @refresh="refresh()"
    />

    <!-- Snackbar for notifications -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="4000">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  webserver,
  getToday,
  getdays_ago,
  formatCurrency,
} from "@/services/webserver.js";
import noteViewer from "@/components/doc_viewer_docs.vue";

export default {
  components: { noteViewer },
  data() {
    return {
      snackbar: false,
      snackbarColor: "info",
      text: "",

      // Filtros simplificados para POS
      filters: {
        dateFrom: getdays_ago(-30), // Últimos 30 días por defecto
        dateTo: getToday(),
        supplier: null,
      },

      loading_status: false,
      dialog: false,

      // Headers simplificados - sin columnas de múltiples tiendas
      headers: [
        {
          text: "Fecha",
          align: "start",
          sortable: true,
          value: "order_date",
          width: "120px",
        },
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "order_id",
        },
        {
          text: "Proveedor",
          align: "start",
          sortable: true,
          value: "proveedor",
        },
        {
          text: "Edad",
          align: "center",
          sortable: true,
          value: "order_age",
          width: "100px",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "ordered_qty",
        },
        {
          text: "Entregados",
          align: "end",
          sortable: true,
          value: "delivered_qty",
        },
        {
          text: "Pendientes",
          align: "center",
          sortable: true,
          value: "difference_qty",
          width: "110px",
        },
        {
          text: "Costo",
          align: "end",
          sortable: true,
          value: "ordered_cost",
        },
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "actions",
          width: "100px",
        },
      ],

      order_list: [],
      item: {
        document: { doc_number: "N/A" },
        buyer: {},
        items: [],
        payments: [],
        company: {},
        seller: {},
      },
      lStatus: "",
      suppliers: [],
    };
  },

  computed: {
    // Nombre de la tienda actual
    currentStoreName() {
      return window.store?.store_name || "Mi Tienda";
    },

    // Computed properties para KPIs (igual que antes)
    getTotalOrderedQty() {
      return this.order_list.reduce(
        (total, order) => total + (parseInt(order.ordered_qty) || 0),
        0
      );
    },
    getTotalDeliveredQty() {
      return this.order_list.reduce(
        (total, order) => total + (parseInt(order.delivered_qty) || 0),
        0
      );
    },
    getDeliveredPercentage() {
      if (this.getTotalOrderedQty === 0) return 0;
      return Math.round((this.getTotalDeliveredQty / this.getTotalOrderedQty) * 100);
    },
    getAverageAge() {
      if (this.order_list.length === 0) return 0;
      const totalAge = this.order_list.reduce(
        (total, order) => total + (parseInt(order.order_age) || 0),
        0
      );
      return Math.round(totalAge / this.order_list.length);
    },
    getTotalOrderedCost() {
      return this.order_list.reduce((total, order) => {
        const costStr = (order.ordered_cost || "0").toString().replace(/[^0-9.-]+/g, "");
        return total + (parseFloat(costStr) || 0);
      }, 0);
    },
  },

  mounted() {
    this.get_supplier();
    // Cargar órdenes automáticamente si hay datos básicos
    if (window.store?.store_id) {
      this.get_orders();
    }
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-CO", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    showMessage(message, color = "info") {
      this.text = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    formatCurrency,

    getAgeColor(age) {
      if (!age) return "grey";
      age = parseInt(age);
      if (age <= 7) return "success";
      if (age <= 15) return "warning";
      return "error";
    },

    new_order() {
      if (this.filters.supplier == null) {
        this.text = "Seleccione un proveedor antes de crear una nueva orden";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      // Navigate to Order component with supplier parameter
      this.$router.push({
        name: "Order",
        params: {
          supplier: {
            code: this.filters.supplier.codigo,
            nombre: this.filters.supplier.nombre,
            id_nit: this.filters.supplier.id_nit,
            direccion: this.filters.supplier.direccion,
            ciudad: this.filters.supplier.Ciudad,
            email: this.filters.supplier.email,
            celular: this.filters.supplier.telefono,
          },
        },
      });
    },

    refresh() {
      this.get_orders();
    },

    get_supplier() {
      this.loading_status = true;
      const qry = {
        store: window.profile.store_id,
        table: "proveedores",
        filters: [
          {
            field: "store",
            operator: "=",
            value: window.profile.store_id.substring(0, 6),
          },
        ],
      };
      webserver(
        "get_dataTable",
        qry,
        (data) => {
          this.loading_status = false;
          console.log(data);
          this.suppliers = data.map((itm) => ({
            ...itm,
            code: itm.codigo,
            PartyIdentification: itm.id_nit,
            PartyName: itm.nombre,
            AddressLine: itm.direccion,
            CityName: itm.Ciudad,
            client_email: itm.email,
            client_phone: itm.telefono,
          }));
          this.showMessage(`${this.suppliers.length} proveedores cargados`, "success");
        },
        (error) => {
          this.loading_status = false;
          this.showMessage("Error al cargar proveedores: " + error, "error");
        }
      );
    },

    // Método simplificado - solo consulta la tienda actual
    get_orders() {
      if (!window.store?.store_id) {
        this.text = "No se puede identificar la tienda actual";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      if (!this.filters.supplier) {
        this.text = "Seleccione un proveedor para realizar la búsqueda";
        this.snackbarColor = "warning";
        this.snackbar = true;
        return;
      }

      this.loading_status = true;
      this.lStatus = "Cargando órdenes de compra...";
      this.order_list = [];

      const qry = {
        store: window.store.store_id, // Solo la tienda actual
        from: this.filters.dateFrom,
        to: this.filters.dateTo,
        supplier: this.filters.supplier.codigo,
      };
      console.log("Consultando órdenes con los siguientes filtros:", qry);

      webserver("get_orders", qry, (data) => {
        this.loading_status = false;
        console.log("Órdenes obtenidas:", data);
        if (data && data.length > 0) {
          this.order_list = data;
          this.text = `Se encontraron ${data.length} órdenes`;
          this.snackbarColor = "success";
          this.snackbar = true;
        } else {
          this.order_list = [];
          this.text = "No se encontraron órdenes con los criterios seleccionados";
          this.snackbarColor = "info";
          this.snackbar = true;
        }
      });
    },

    get_e_doc(e) {
      const doc = {
        store: window.store.store_id, // Siempre la tienda actual
        issueDate: e.order_date,
        did: e.order_id,
      };

      this.loading_status = true;
      this.lStatus = "Cargando documento...";

      webserver("get_invoice_fe", doc, (data) => {
        this.loading_status = false;
        if (data) {
          this.item = data;
          this.dialog = true;
        } else {
          this.text = "No se pudo cargar el documento";
          this.snackbarColor = "error";
          this.snackbar = true;
        }
      });
    },
  },
};
</script>

<style>
.order-kpi-card {
  transition: transform 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.order-kpi-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

@media (max-width: 960px) {
  .v-card {
    margin-bottom: 16px;
  }
  .py-2 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
}
</style>
